import { createSlice } from '@reduxjs/toolkit';

const { reducer, actions } = createSlice({
  name: 'replayPositions',
  initialState: {
    positions: [],
    subPositions: [],
    index: 0,
    distanceAccu: 0,
  },
  reducers: {
    setPositions(state, action) {
      state.positions = action.payload;
    },
    setSubPositions(state, action) {
      state.subPositions = action.payload;
    },
    setIndex(state, action) {
      state.index = action.payload;
    },
    setDistanceAccu(state, action) {
      state.distanceAccu = action.payload;
    },
    reset(state) {
      state.positions = [];
      state.subPositions = [];
      state.index = 0;
      state.distanceAccu = 0;
    },
  }
});

export { actions as replayPositionsActions };
export { reducer as replayPositionsReducer };
